import { FormEvent, useState } from "react";

type PublicVerifyCodePageProps = {
  phone: string;
  onVerifySuccess: () => void;
};

export default function PublicVerifyCodePage({
  phone,
  onVerifySuccess,
}: PublicVerifyCodePageProps) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const sanitized = code.replace(/\D/g, "");

    if (!/^\d{6}$/.test(sanitized)) {
      setError("El código debe tener 6 digitos numericos.");
      return;
    }

    if (sanitized !== "123456") {
      setError("Código invalido. Usa 123456.");
      return;
    }

    setError("");
    onVerifySuccess();
  };

  return (
    <main className="auth-layout">
      <section className="card auth-card">
        <h1>Verificacion</h1>
        <p className="subtitle">
          Ingresa el código de 6 digitos enviado al teléfono{" "}
          <strong>{phone}</strong>.
        </p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label htmlFor="verify-code">Código</label>
          <input
            id="verify-code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            placeholder="123456"
            value={code}
            onChange={(event) => setCode(event.target.value.replace(/\D/g, ""))}
          />
          {error ? <p className="error">{error}</p> : null}
          <button type="submit">Validar código</button>
        </form>
      </section>
    </main>
  );
}
